<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>渠道管理</span>
            <div class="add_main_channel jm-fr">
              <el-button icon="el-icon-plus" type="primary" v-permission="[1, 62, 81]" @click="show_detail(channelData, true)">
                添加主渠道
              </el-button>
              <el-button icon="el-icon-refresh" type="warning" :disabled="isBuilding" v-permission="[1, 62]" @click="handleBuildChannelMap">
                {{ isBuilding ? '正在构建 ...' : '构建渠道缓存' }}
              </el-button>
              <el-button icon="el-icon-delete" type="success" :disabled="isClearing" v-permission="[1]" @click="handleClearCache">
                {{ isClearing ? '正在清理 ...' : '清理系统缓存' }}
              </el-button>
            </div>
          </div>
          <el-form label-width="80px" :inline="true" :model="searchForm">
            <el-form-item label="渠道号">
              <el-input type="number" v-model.number="searchForm.ch_id">
                <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-tag
                class="tag-class"
                :style="{ 'color': tag.ch_color }"
                v-for="tag in searchChannels"
                :key="tag.ch_id"
                type="success">
                {{ tag.ch_name }}
              </el-tag>
            </el-form-item>
          </el-form>

          <!--渠道表单-->
          <el-row class="num" :gutter="5">
            <el-col :span="8" v-for="(v, k) in channels" :key="k">
              <p class="num-title">{{ v.title }}</p>
              <div
                v-for="(list, index) in v.data"
                :key="index">
                <div style="margin-top: 10px;" v-if="!list.ch_status">
                  <el-tooltip class="item" effect="dark" :content="`渠道ID: ${list.ch_id} 渠道名称：${list.ch_name}`" placement="right">
                    <span
                      :class="{ active_color: v.current === list.ch_id}"
                      @click="() => handleChannelClick(list) && getNextChannels(list.ch_id, list.ch_level + 1)"
                      :style="`color: ${list.ch_status ? '#888' : list.ch_color};border: 1px solid ${list.ch_status ? '#888' : list.ch_color};width: 150px;display: inline-block;cursor:pointer;`"
                    >
                      {{ list.ch_name }}
                    </span>
                  </el-tooltip>
                  <span class="channel-order" :style="`background-color: ${list.ch_status ? '#888' : list.ch_color}`">{{ list.ch_order === 9999 ? '' : list.ch_order }}</span>
                  <div class="operate-container" v-permission="[1, 62, 81]">
                    <span
                      v-if="!list.ch_status && list.ch_url == '' && list.ch_level < 5"
                      @click="show_detail(list, true)"
                      class="ch_edit">添加子渠道</span>
                    <span v-if="!list.ch_status && !(list.ch_url == '' && list.ch_level < 5)" style="color: #ff6600" class="ch_edit" @click="copy_link(list.ch_url,list.ch_id)">复制此链接</span>
                    <span v-if="!list.ch_status" @click="show_detail(list)" class="ch_edit">编辑</span>
                    <span
                      :class="{ ch_disable: list.ch_status, ch_edit: !list.ch_status }"
                      @click = "disable_channel(list)"
                    >
                      {{ list.ch_status ? '启用' : '禁用' }}
                    </span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加渠道"
      :visible.sync="dialogVisible"
      width="30%">
      <el-form label-width="100px" :form="channelData" >
        <el-form-item label="渠道编号：">
          <el-input v-model="channelData.custom_id" autofocus class="jm-input280"></el-input>
        </el-form-item>
        <el-form-item label="默认推广人：">
          <el-select
            filterable
            v-model="channelData.default_member"
            class="jm-input280"
            clearable
            placeholder="请选择">
            <el-option
              v-for="item in dict.teachers"
              :key="item.userid"
              :label="item.username"
              :value="item.userid"/>
          </el-select>
          <el-tooltip placement="top">
            <div slot="content">
              <strong>默认推广人</strong>
              <p>① 设定当前渠道的默认推广人，以便前端渠道注册使用；</p>
              <p>② 在“商务合作渠道”下，“市场中心”老师可维护该渠道客户。</p>
            </div>
            <i class="el-icon-question" style="margin-left: 10px" />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="推广负责人：">
          <el-select
            filterable
            :multiple="true"
            v-model="channelData.memberIds"
            class="jm-input280"
            clearable
            placeholder="请选择">
            <el-option
              v-for="item in dict.teachers"
              :key="item.userid"
              :label="item.username"
              :value="item.userid"/>
          </el-select>
        </el-form-item>
        <el-form-item label="中心负责人：">
          <el-select
            filterable
            :multiple="true"
            v-model="channelData.center_memberIds"
            class="jm-input280"
            clearable
            placeholder="请选择">
            <el-option
              v-for="item in dict.teachers"
              :key="item.userid"
              :label="item.username"
              :value="item.userid"/>
          </el-select>
        </el-form-item>
        <el-form-item label="父级渠道：">
          <el-select
            filterable
            :multiple="false"
            v-model="channelData.ch_sid"
            class="jm-input280"
            clearable
            placeholder="请选择">
            <el-option :label="`Root(一级渠道的父渠道) - ID:0`" :value="0" />
            <el-option
              v-for="item in dict.channels"
              :key="item.ch_id"
              :label="`${item.path_str ? item.path_str + '-' : ''}${item.ch_name} - ID:${item.ch_id}`"
              :value="item.ch_id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="名称：">
          <el-input v-model="channelData.ch_name" autofocus class="jm-input280"></el-input>
        </el-form-item>
        <el-form-item label="URl：">
          <el-input ref="urlInput" class="jm-input280" v-model="channelData.ch_url"> </el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="颜色：">
              <el-select v-model="channelData.ch_color" placeholder="请选择">
                <el-option
                  :style="{ color: item.value }"
                  v-for="item in channel_color"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特殊渠道：" label-width="100px">
              <el-checkbox v-model="channelData.is_special"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="顺序：">
              <el-input
                type="number"
                v-model="channelData.ch_order"
                class="jm-input90">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="星图不拉取：" label-width="100px">
              <el-checkbox v-model="channelData.no_training_pull"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="channelData.ch_id">
          <el-form-item label="话术：">
            <el-input class="jm-input280" v-model="channelData.speechcraft"></el-input>
          </el-form-item>
          <el-form-item label="宽度：">
            <el-input class="jm-input280" type="number" placeholder="200" v-model="qrCodeOptions.width"></el-input>
          </el-form-item>
          <el-form-item label="参数：">
            <el-input class="jm-input280" v-model="qrCodeOptions.params"></el-input>
          </el-form-item>
          <el-form-item label="二维码类别：">
            <el-select class="jm-input280" v-model="channelData.ch_type">
              <el-option v-for="{ value, label } in wxApps" :key="value" :value="value" :label="label">{{ label }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型：" v-if="channelData.ch_type > 0">
            <el-switch
              v-model="qrCodeOptions.code_type"
              active-color="#13ce66"
              inactive-color="#409EFF"
              :active-value="2"
              :inactive-value="1"
              inactive-text="二维码（方）"
              active-text="小程序码（圆）">
            </el-switch>
          </el-form-item>
          <el-form-item label="二维码：" v-if="channelData.ch_qrurl">
            <img class="qrcode" v-if="channelData.ch_qrurl" :src="qrcodeUrl" />
          </el-form-item>
        </template>
        <el-form-item label="所属系统：">
          <el-select
            v-model="channelData.site_dic_key"
            filterable
            class="jm-input280"
            clearable
            :multiple="true"
            placeholder="请选择">
            <el-option
              v-for="item in dict.dictSite"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="channelData.ch_id" @click="makeQrcode">生成二维码</el-button>
        <el-button type="primary" :loading="btnLoading" @click="add_channel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import '@/assets/css/index.css';
import { deepClone } from '@/utils/utils.js';

let defaultChannel = {
  ch_name: '',
  ch_url: '',
  is_special: false,
  no_training_pull: false,
  ch_order: '',
  ch_color: '#3bafda',
  ch_sid: 0,
  ch_level: 0,
  ch_status: 0,
  site_dic_key: [],
  center_memberIds: [],
  memberIds: [],
  default_member: 0
};

export default {
  name: 'ChannelManage',
  data() {
    return {
      searchForm: {
        ch_id: null
      },
      searchChannels: [],
      wxApps: {},
      qrCodeOptions: {
        width: 200,
        code_type: 1,
      },
      dialogVisible: false,
      channelData: deepClone(defaultChannel),
      currentChannel: null, // 当前渠道数据
      channel_color: [
        {
          value: '#3bafda',
          label: '浅蓝色'
        },
        {
          value: '#339933',
          label: '墨绿色'
        },
        {
          value: '#ff6600',
          label: '橘红色'
        },
        {
          value: '#cc0033',
          label: '鲜红色'
        },
        {
          value: '#0066cc',
          label: '深蓝色',
        }
      ],
      channels: {
        level_1: {
          title: '主渠道',
          data: [],
          current: null
        },
        level_2: {
          title: '二级渠道',
          data: [],
          current: null
        },
        level_3: {
          title: '三级渠道',
          data: [],
          current: null
        },
        level_4: {
          title: '四级渠道',
          data: [],
          current: null
        },
        level_5: {
          title: '五级渠道',
          data: [],
          current: null
        }
      },
      dict: {
        dictSite: [],
        teachers: [],
        channels: []
      },
      isBuilding: false,
      isClearing: false,
      btnLoading: false,
    };
  },
  computed: {
    qrcodeUrl() {
      return this.channelData.ch_qrurl;
    }
  },
  methods: {
    handleChannelClick (channel) {
      this.channelData = channel;
      return true;
    },
    /**
     * 获取下一级渠道
     * @param {Number} chId
     * @param {Number} level
     */
    getNextChannels(pId, level, clearData = true) {
      if (level > 5) {
        return true;
      }
      return new Promise((resolve) => {
        this.$http
          ._post({
            url: '/training/channel/mainChannel',
            data: {
              ch_level: level,
              ch_sid: pId
            }
          })
          .then(({ data }) => {
            let currentLevel = level - 1;
            this.channels[`level_${level}`].data = data;
            currentLevel &&
              (this.channels[`level_${currentLevel}`].current = pId);
            clearData && this.clearNextLevelData(level + 1);
            resolve(data);
          });
      });
    },
    /**
     * 清除下属渠道内容
     */
    clearNextLevelData(level) {
      while (level <= 5) {
        this.channels[`level_${level}`].data = [];
        this.channels[`level_${level}`].current = null;
        level++;
      }
    },
    /**
     * @param {Object} data
     * @param {Boolean} isNew 是否为添加
     */
    show_detail(data, isNew = false) {
      if (isNew) {
        if (data.ch_level >= 5) {
          return false;
        }
        this.channelData = deepClone(defaultChannel);
        this.channelData.ch_level = data.ch_level;
        this.channelData.ch_sid = data.ch_id;
      } else {
        if (data.site_dic_key[0] === '') {
          data.site_dic_key = [];
        }
        if (data.center_memberIds[0] === 0) {
          data.center_memberIds = [];
        }
        this.currentChannel = data;
        this.channelData = deepClone(data);
      }
      this.channelData.isNew = isNew;
      this.dialogVisible = true;
    },
    add_channel(closeDialog = true) {
      this.btnLoading = true;
      if (this.channelData.ch_name === undefined) {
        this.$message.error('渠道名不能为空');
        return false;
      }
      if (this.channelData.site_dic_key.length === 0) {
        this.$message.error('所属系统不能为空');
        return false;
      }
      const postData = {
        ...this.channelData,
        ch_level: this.channelData.ch_level + (
          this.channelData.isNew ? 1 : 0
        ),
        ch_sid: this.channelData.ch_sid || 0
      };
      delete postData.members;
      this.$http
        ._post({
          data: {
            channelData: postData
          },
          url: '/training/channel/addChannel'
        })
        .then(({ data }) => {
          if (data === '数据库错误' || data === '顺序重复') {
            this.$message.error(data);
          } else {
            this.$message.success(data);
            closeDialog && (this.dialogVisible = false);

            // 更新下级
            this.getNextChannels(
              postData.ch_sid,
              postData.ch_level
            );
            // 新增
            if (!postData.ch_id) {
              return true;
            }
            Object.entries(postData).forEach(([k, v]) => {
              this.$set(postData, k, v);
            });
          }
        }).finally(() => {
          this.btnLoading = false;
        });
    },
    disable_channel(item) {
      let newStatus = !item.ch_status;
      this.$http
        ._post({
          data: {
            ch_id: item.ch_id,
            ch_status: newStatus
          },
          url: '/training/channel/disableChannel'
        })
        .then(({ data }) => {
          this.$message.success(data);
          item.ch_status = newStatus;
        });
    },
    copy_link(chUrl, chId) {
      let array = [];
      let link = '?v=';
      array.push(chUrl, link, chId);
      let url = array.join('');
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      this.$message.success('链接已复制');
    },
    /**
     * 检索渠道
     */
    doSearch() {
      if (!this.searchForm.ch_id) {
        return;
      }

      this.clearNextLevelData(2);
      this.$http
        ._get({
          url: '/training/channel/doSearch',
          data: { chId: this.searchForm.ch_id }
        })
        .then(({ data }) => {
          this.searchChannels = data;
          data.forEach((item) => {
            this.getNextChannels(item.ch_id, item.ch_level + 1, false);
          });
        });
    },
    getWxAppTypes() {
      this.$http._get({
        url: '/index/api_base/wxapplist',
      }).then(({ data }) => {
        this.wxApps = data;
      });
    },
    /**
     * 生成二维码
     */
    makeQrcode() {
      if (!this.channelData.ch_url) {
        this.$message.warning('URL地址为空！');
        this.$refs.urlInput.focus();
        return false;
      }
      this.$http._post({
        url: '/training/channel/makeQrCode',
        data: {
          ...this.qrCodeOptions,
          url: this.channelData.ch_url,
          id: this.channelData.ch_id,
          type: this.channelData.ch_type,
        }
      }).then(({ data }) => {
        this.channelData.ch_qrurl = data;
        this.add_channel(false);
      });
    },
    getDict() {
      this.$http._get({
        url: '/training/channel/getDicts'
      }).then(({ data }) => {
        this.dict = data;
      });
    },
    handleBuildChannelMap() {
      this.$confirm('确定要重新构建吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!this.isBuilding) {
          this.isBuilding = true;
          this.$http._get({
            url: '/training/channel/buildChannelMap'
          }).then(() => {
            this.isBuilding = false;
            this.getDict();
            this.$message.success('构建缓存完毕');
          });
        }
      });
    },
    handleClearCache() {
      this.$confirm('确定要清理系统缓存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!this.isClearing) {
          this.isClearing = true;
          this.$http._get({
            url: '/index/api_base/clearCache'
          }).then(() => {
            this.isClearing = false;
            this.$message.success('系统缓存清理完毕');
          });
        }
      });
    },
  },
  created() {
    this.getNextChannels(0, 1);
    this.getWxAppTypes();
    this.getDict();
  },
};
</script>
<style scoped>
.num p {
  text-align: center;
}
.num .num-count {
  text-align: center;
  cursor: pointer;
}
.num .num-title {
  background-color: #050b21;
  font-size: 18px;
  color: white;
}
.active_color {
  color: #fff !important;
  background-color: #000 !important;
}
.table-agile-info .operate-container span {
  color: #3bafda;
}
.channel_style {
  cursor: pointer;
  color: #3bafda;
  width: 100px;
  border: 1px solid #3bafda;
  margin-top: 10px;
}
.channel-order {
  color: #fff !important;
  width: 20px;
  text-align: center;
  display: inline-block;
}
.add_main_channel {
  margin-bottom: 10px;
}
.ch_edit {
  margin-left: 20px;
  cursor: pointer;
}
.ch_disable {
  margin-left: 20px;
  color: #ff6600 !important;
  cursor: pointer;
}
.tag-class {
  margin-right: 10px;
}
.qrcode {
  width: 200px;
}
.operate-container {
  display: inline;
}
</style>
